import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { baseUrl } from "api";
import { API_ENDPOINTS } from "api/apiEndPoints";

const PaymentFailurePage: React.FC = () => {
  const { uuid } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [order, setOrder] = useState<any>(null);

  useEffect(() => {
    const controller = new AbortController();
    async function fetchOrder() {
      try {
        setLoading(true);
        setError(null);
        const res = await fetch(
          `${baseUrl}${API_ENDPOINTS.SalesOrderByUuid}/${uuid}`,
          { signal: controller.signal }
        );
        const json = await res.json();
        if (!res.ok || !json?.success) {
          setError(json?.message || "Order not found");
        } else {
          setOrder(json.data);
        }
      } catch (e: any) {
        if (e.name !== "AbortError") setError("Unable to load order details. Please try again.");
      } finally {
        setLoading(false);
      }
    }
    if (uuid) fetchOrder();
    return () => controller.abort();
  }, [uuid]);

  if (loading) {
    return (
      <div className="container py-16">
        <h2 className="text-2xl font-semibold">Loading...</h2>
      </div>
    );
  }

  const cancellation = order?.cancellation_reason || "Payment was not completed";

  return (
    <div className="container py-16">
      <h2 className="text-2xl font-semibold text-red-600">Payment Failed</h2>
      <p className="mt-2">Your payment could not be processed. Please try again.</p>

      {error ? (
        <p className="mt-4">{error}</p>
      ) : (
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-3">Failure Information</h3>
            <div className="space-y-1 text-sm">
              <div><strong>Reason:</strong> {cancellation}</div>
              <div><strong>Order Number:</strong> {order?.sales_order_no}</div>
              <div><strong>Attempted Amount:</strong> ₹{order?.famount}</div>
              <div><strong>Payment Status:</strong> {order?.payment_status}</div>
            </div>

            <h3 className="text-lg font-semibold mt-6 mb-2">You can</h3>
            <ul className="list-disc ml-5 text-sm space-y-1">
              <li>Your order has been saved</li>
              <li>No money has been deducted from your account</li>
              <li>You can retry the payment anytime</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-3">Actions</h3>
            <div className="flex flex-wrap gap-3">
              <Link className="px-4 py-2 rounded-2xl bg-slate-900 text-white" to={`/order/${order?.uuid}`}>Retry Payment</Link>
              <Link className="px-4 py-2 rounded-2xl border" to="/cart">Go to Cart</Link>
              <Link className="px-4 py-2 rounded-2xl border" to="/contact">Contact Support</Link>
              <Link className="px-4 py-2 rounded-2xl border" to={`/order/${order?.uuid}`}>View Order</Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentFailurePage;


